
// shared
import shared from './shared';

// vue
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    setup() {

        return {
            ...shared(),
        };
    },
});
